import React from 'react';
import Container from '~/components/ui/Container';
import { textContent, type MortgageType } from '~/pages/Tools/CalculateMaximumMortgage/Index/data';

const IndexMortgageTypesSection: React.FC = () => {
  const { mortgageTypes } = textContent;
  
  if (!mortgageTypes?.length) return null;
  
  return (
    <section className="bg-white py-14">
      <Container>
        <h2 className="font-display text-blue-600 font-bold text-center md:text-left text-xl md:text-3xl mb-8">Hypotheekvormen vergelijken</h2>

        <div className="md:-mx-5">
          <header className="hidden md:block">
            <div className="grid md:grid-cols-4">
              <div className="p-5">
                <h4 className="text-black font-display font-bold text-lg">Hypotheekvorm</h4>
              </div>
              <div className="p-5">
                <h4 className="text-black font-display font-bold text-lg">Kenmerken</h4>
              </div>
              <div className="p-5">
                <h4 className="text-black font-display font-bold text-lg">Voordelen</h4>
              </div>
              <div className="p-5">
                <h4 className="text-black font-display font-bold text-lg">Nadelen</h4>
              </div>
            </div>
          </header>
          <main>
            {mortgageTypes.map(({ title, description, pros, cons }: MortgageType) => (
              <div className="grid md:grid-cols-4 rounded-lg odd:bg-blue-25" key={title}>
                <div className="px-4 pt-4 md:p-5">
                  <strong className="text-lg md:text-base font-display md:font-body font-bold">
                    {title}
                  </strong>
                </div>
                <div className="px-4 pt-4 md:p-5">
                  <h4 className="md:hidden font-bold">Kenmerken:</h4>
                  <p>{description}</p>
                </div>
                <div className="px-4 pt-4 md:p-5">
                  <h4 className="md:hidden font-bold">Voordelen:</h4>
                  <ul className="list-disc pl-4">
                    {pros.map(pro => (
                      <li>{pro}</li>
                    ))}
                  </ul>
                </div>
                <div className="px-4 pt-4 pb-4 md:p-5">
                  <h4 className="md:hidden font-bold">Nadelen:</h4>
                  <ul className="list-disc pl-4">
                    {cons.map(con => (
                      <li>{con}</li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </main>
        </div>
      </Container>
    </section>
  );
};

export default IndexMortgageTypesSection;